import { RefObject, createContext, useContext } from 'react';
import { ScrollView } from 'react-native';

export const CardBlockScrollContext = createContext<RefObject<ScrollView> | null>(null);

export function useCardBlockScrollContext() {
  return useContext(CardBlockScrollContext);
}
